import React from 'react';
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';

import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
    name: "dragAndDropGame",
    subSection: true,
    resource: true,
    hideIfResourceIsNoU: true,

    fields: [
        {
          name: 'stacks.0',
          resource: true,
          subSection: true,
          fields: [
// legacy oddness
            // {
            //     type: 'contenteditable',
            //     name: 'headline',
            //     required: true,
            //     // Headline is only allowed if there is more than one step
            //     showField: (proxy) => (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
            //     linkedField: (proxy) => ["title"],
            //     props: {
            //         labelKey: 'editbreak.steps.drag_drop.headline'
            //     }
            // },
            {
              type: 'image',
              name: 'exampleImageId',
              idFor: 'exampleImage',
              required: false,
              props: {
                labelKey: 'editbreak.steps.drag_drop.example_image',
                imageType: 'dragDropPuzzleExample'
              }
            },
            {
                type: 'contenteditable',
                name: 'introCopy',
                required: false,
                props: {
                  labelKey: 'editbreak.steps.drag_drop.intro_copy',
                  maxLength: 500,
                  placeholderKey: 'editbreak.steps.drag_drop.intro_copy.placeholder',
                  validationRules: [
                      {
                          type: 'MarkupTextLimit',
                          params: {
                              limit: 500
                          }
                      }
                  ]

                }
            },

            {
                type: 'contenteditable',
                name: 'startTitle',
                required: false,
                props: {
                  labelKey: 'Start Screen Title',
                  placeholderKey: 'Rank the podcasts',

                }
            },
            {
                type: 'contenteditable',
                name: 'startBody',
                required: false,
                props: {
                  labelKey: 'Start Screen Body',
                }
            },


            {
                type: 'contenteditable',
                name: 'resultTitle',
                required: false,
                props: {
                  labelKey: 'Result Screen Title',
                //   placeholderKey: '',
                }
            },

            {
                type: 'contenteditable',
                name: 'resultBody',
                required: false,
                props: {
                  labelKey: 'Result Screen Body Copy',
                //   placeholderKey: 'Drag items from the bottom to the top',

                }
            },

// legacy
            // {
            //     type: 'contenteditable',
            //     name: 'description',
            //     required: false,
            //     props: {
            //       labelKey: 'editbreak.steps.drag_drop.body_copy',
            //       placeholderKey: 'editbreak.steps.drag_drop.body_copy.placeholder'
            //     }
            // },
            {
                type: 'text',
                name: 'commentQuestion',
                showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentBaseResource.sponsoredType !== 'sponsored' ),
                props: {
                    labelKey: 'editbreak.steps.related_breaks.commentQuestion',
                    helpContent: <FBCommentQuestionToolTip/>,
                    helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.fbCommentQuestion'}/></IntlProvider>
                }
            },
            {
              type: "hardcodedText",
              props: {
                heading: "Game Modes Guide",
                text: () => (
                  <span>
                    <b>Ranking:</b> Force Correct Answer - No / Shuffle Target Order
                    - No
                    <br />
                    <b>Order:</b> Force Correct Answer - Yes / Shuffle Target Order
                    - No
                    <br />
                    <b>Pairs:</b> Force Correct Answer - Yes / Shuffle Target Order
                    - Yes
                  </span>
                ),
              },
            },
            {
              type: 'radio',
              name: 'dragDropType',
              required: true,
              props: {
                labelKey: 'editbreak.steps.drag_drop.type',
                options: [
                  {
                    value: 'PuzzleDrop',
                    textKey: 'editbreak.steps.drag_drop.type.puzzle'
                  },
                  {
                    value: 'MatchDrop',
                    textKey: 'editbreak.steps.drag_drop.type.match'
                  }
                ]
              }
            },
            {
              name: 'hasScoring',
              type: 'yesnoradio',
              required: true,
              props: {
                labelKey: 'editbreak.steps.drag_drop.force_correct_answer'
              }
            },
              {
                  name: 'requireAllCardsPlaced',
                  type: 'yesnoradio',
                  props: {
                      labelKey: 'editbreak.steps.drag_drop.require_all_cards_placed'
                  }
              },
            {
              name: 'puzzleTargetImageId',
              type: 'image',
              idFor: 'puzzleTargetImage',
              showField: (proxy) => (proxy.currentResource.dragDropType === 'PuzzleDrop'),
              props: {
                labelKey: 'editbreak.steps.drag_drop.puzzle_target_image'
              }
            },
            {
              name: 'shuffleSlots',
              type: 'yesnoradio',
              showField: (proxy) => (proxy.currentResource.dragDropType === 'MatchDrop'),
              required: true,
              props: {
                labelKey: 'editbreak.steps.drag_drop.shuffle_slots'
              }
            },
            {
              subSection: true,
              key: "puzzleCardsContainer",
              sectionWrapper: IndexedSubSectionWrapper,
              showSection: (proxy) => (proxy.currentResource.dragDropType === 'PuzzleDrop'),
              props: {
                headerKey: 'editbreak.steps.drag_drop.cards.puzzle_header'
              },
              fields: [
                {
                    name: 'cards',
                    subSection: true,
                    resource: true,
                    collection: true,

                    fields: [
                      {
                        name: 'cardImageId',
                        type: 'image',
                        idFor: 'cardImage',
                        required: true,
                        props: {
                          labelKey: 'editbreak.steps.drag_drop.cards.puzzle_image',
                          imageType: 'dragDropCardImage'
                        }
                      }
                    ]
                } // end puzzle cards
              ]
            }, // end puzzle cards container accordion
            {
              subSection: true,
              key: "matchCardsContainer",
              sectionWrapper: IndexedSubSectionWrapper,
              showSection: (proxy) => (proxy.currentResource.dragDropType === 'MatchDrop'),
              props: {
                headerKey: 'editbreak.steps.drag_drop.cards.match_header'
              },
              fields: [
                  {
                      type: 'radio',
                      name: 'gridSize',
                      required: true,
                      props: {
                          labelKey: 'editbreak.steps.drag_drop.grid_size',
                          colCount: 3,
                          options: [
                              {
                                  value: 4,
                                  textKey: 'editbreak.steps.drag_drop.grid_size.4'
                              },
                              {
                                  value: 8,
                                  textKey: 'editbreak.steps.drag_drop.grid_size.8'
                              },
                              {
                                  value: 12,
                                  textKey: 'editbreak.steps.drag_drop.grid_size.12'
                              }
                          ]
                      }
                  },
                {
                    name: 'cards',
                    subSection: true,
                    resource: true,
                    collection: true,

                    fields: [
                      {
                        name: 'cardImageId',
                        type: 'image',
                        idFor: 'cardImage',
                        required: true,
                        props: {
                          labelKey: 'editbreak.steps.drag_drop.cards.match_drag_image',
                          imageType: 'dragDropCardImage'
                        }
                      },
                      {
                        name: 'backgroundImageId',
                        type: 'image',
                        idFor: 'backgroundImage',
                        required: true,
                        props: {
                          labelKey: 'editbreak.steps.drag_drop.cards.match_target_image',
                          imageType: 'dragDropCardImage'
                        }
                      }
                    ]
                } // end match cards
              ]
            } // end match cards container accordion
          ]
        }
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/drag-and-drop.js